import React from 'react'
import { Switch as ChakraSwitch, SwitchProps } from '@chakra-ui/react'
import { brandColors } from '../../../../../../shared/basicPalette'
import { css } from '@emotion/react'
import { ThemingProps } from '@chakra-ui/system/dist/types/system.types'
import { useLooopTheme } from '../../../../public-api/hooks/useLooopTheme'
import { Box } from 'front-end/src/components'

type CustomSwitchProps = SwitchProps & {
  colorScheme?: ThemingProps['colorScheme'] & 'warning'
  dataTest?: string
}

export const Switch = ({
  dataTest = 'Switch',
  ...props
}: CustomSwitchProps) => {
  const { theme } = useLooopTheme()
  return (
    <ChakraSwitch
      data-test={dataTest}
      css={css`
        position: relative;
        & > .chakra-switch__track[aria-checked='true'],
        .chakra-switch__track[data-checked] {
          background-color: ${props.colorScheme === 'warning'
            ? brandColors.orange.mid
            : theme.colors.buttonPrimary.default};
        }

        @media all and (-ms-high-contrast: none) {
          /* IE11 */
          *::-ms-backdrop,
          & > input {
            width: auto !important;
            height: auto !important;
            clip: auto !important;
            position: static !important;
          }
          *::-ms-backdrop,
          & > .chakra-switch__track {
            display: none !important;
          }
        }
      `}
      {...props}
    />
  )
}

export const SwitchWithLabels = (props: CustomSwitchProps) => {
  return (
    <Box position="relative">
      <Switch
        css={css`
          --slider-track-width: 3.25rem;
        `}
        {...props}
      />
      <Box
        // @ts-ignore
        onClick={() => props?.onChange && props.onChange()}
        userSelect="none"
        cursor="pointer"
        position="absolute"
        top="50%"
        mt="-9px"
        left={props.isChecked ? 0 : '50%'}
        ml="4px"
        fontSize="11px"
        color="white"
        textTransform="uppercase"
      >
        {/* We can't translate this because switch has fixed width */}
        {props.isChecked ? 'Yes' : 'No'}
      </Box>
    </Box>
  )
}
